import type { QueryClient } from "@tanstack/react-query";
import type { AppNotification } from "./api";
import { isMedicalCheckAssignmentNotification } from "./notification-display";

export function mobileNotificationDestination(n: AppNotification): string {
  const id = encodeURIComponent(n.entityId ?? "");
  const detail = `/mobile/inbox?tab=notifications&notification=${encodeURIComponent(n.id)}`;
  if (n.type === "leave_replacement") return "/mobile/calendar";
  // These notices go to a manager/HR about somebody else's request. The mobile
  // personal calendar intentionally cannot read that request; show the notice.
  if (["leave_submitted", "leave_cancelled", "leave_document_uploaded"].includes(n.type)) return detail;
  if (n.type.startsWith("leave_") || n.entityType === "leave_request") return `/mobile/calendar?request=${id}`;
  if (n.entityType === "medical_check") {
    const assignment = n.entityId && isMedicalCheckAssignmentNotification(n.type);
    return `/mobile/medical-check${assignment ? `?assignment=${id}${n.type === "medical_check_confirmed" ? "&legacyEmployeeId=true" : ""}` : ""}`;
  }
  if (n.entityType === "salary" || n.type === "salary_processed") return "/mobile/salary";
  if (n.entityType === "workflow_task") return `/mobile/inbox?tab=tasks&taskId=${id}`;
  if (n.entityType === "corporate_event" || n.type === "event_new") return `/mobile/calendar?event=${id}`;
  return detail;
}

export function invalidateNotificationQueries(client: QueryClient) {
  return Promise.all(["mobile-home-notifications", "mobile-inbox-notifications", "mobile-notif-count", "notifications", "notification-unread-count", "notificationCount", "unread-notifications-count"].map(key =>
    client.invalidateQueries({ queryKey: [key] })));
}
